module.exports = __webpack_public_path__ + "img/37e8dcd08e08191bc5111ceee03cb945.png";